import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LinkContainer } from 'react-router-bootstrap';
import { actionCreators } from '../../store/modules/Email';
import List from '../../containers/List';
import date from '../../utils/date';
import Image, { GetImageSrc } from '../../controls/Image';

const EmailList = (props) => {
  const {
    emails, paging, requestList, preferTable, switchDisplayStyle,
  } = props;

  const columns = [
    {
      id: 'subject',
      Header: 'Temats',
      accessor: 'subject',
      sortable: true,
    },
    {
      id: 'createdOn',
      Header: 'Izveidots',
      accessor: 'createdOn',
      Cell: cell => date.long(cell.value),
      sortable: true,
      width: 160,
    },
    {
      accessor: 'id',
      Cell: cell => (
        <LinkContainer to={`/email/${cell.value}`} exact>
          <div className="gaas-tile-btn">Apskatīt</div>
        </LinkContainer>
      ),
      maxWidth: 120,
      sortable: false,
    },
  ];

  return (
    <List title="E-pasti"
      requestList={requestList}
      {...paging}
      tableData={emails}
      tableColumns={columns}
      preferTable={preferTable}
      switchDisplayStyle={switchDisplayStyle}
      newLink="/email/new">
      {emails.map(email => (
        <div key={email.id}>
          <div className="gaas-tile">
            <div className="gaas-tile-image">
              <Image className="avatar lg" src={GetImageSrc(email.imageId, 80)}
                alt="email" />
            </div>
            <div className="gaas-tile-heading h-img">
              <span className="text-ellipsis">{email.subject}</span>
            </div>
            <div className="gaas-tile-body">
              <div className="m-t-md m-b-md padder">
                <div className="row">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <i className="glyphicon glyphicon-screenshot m-r-sm" />
                    <span className="text-underline">Izveidots</span>
                    {' : '}
                    <span>{date.long(email.createdOn)}</span>
                    <br />
                  </div>
                </div>
              </div>
            </div>
            <div className="gaas-tile-footer m-t-sm" style={{ borderBottomLeftRadius: '50%', borderBottomRightRadius: '50%' }}>
              <LinkContainer to={`/email/${email.id}`} exact>
                <div className="gaas-tile-btn">Apskatīt</div>
              </LinkContainer>
            </div>
            <div className="clear" />
          </div>
        </div>
      ))}
    </List>
  );
};

EmailList.propTypes = {
  emails: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number, name: PropTypes.string })).isRequired,
  requestList: PropTypes.func.isRequired,
  paging: PropTypes.shape({ totalPages: PropTypes.number }).isRequired,
  preferTable: PropTypes.bool.isRequired,
  switchDisplayStyle: PropTypes.func.isRequired,
};

export default connect(
  state => ({
    emails: state.email.list,
    paging: state.email.paging,
    preferTable: state.email.preferTable,
  }),
  dispatch => bindActionCreators(actionCreators, dispatch),
)(EmailList);



// WEBPACK FOOTER //
// ./src/components/email/List.jsx